/** @format */

import React, { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import I18n from '../../components/Translate/I18n';
import { TableBody, TableFooter } from '@material-ui/core';
import { DateHelper } from '../../helpers/DateHelper';
import ViewButton from '../../components/Buttons/ViewButton';
import Pager from '../../components/Adescom/PagerRange';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';
import ViewDialog from '../../components/Dialog/ViewDialog';
import { provisionigConstants } from '../../modules/provisioning/action';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import NotifyView from '../../views/Provisioning/components/NotifyView';
import { store } from '../../core/store';
import { provisioningReducers } from '../../modules/provisioning/reducers';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { PlatformResellerLoader } from '../../modules/platformreseller/PlatformResellerLoader';
import { FilterManager } from '../../modules/filter/FilterManager';
import TableHeaderContentCell from '../../components/Table/TableHeaderContentCell';
import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';
import SimCardInterface from '../../interfaces/platform/SimCardInterface';
import { FilterReducerFieldName, FilterReducers } from '../../modules/filter/FilterReducers';
import PlusNotifyInterface, { PlusNotifyCollectionInterface } from '../../interfaces/platform/PlusNotifyInterface';
import { HeaderCheckBoxSelectListElement } from '../lib/search/listTableHeader/HeaderCheckBoxSelectList';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import FilterList from '../../components/Filter/FilterList';
import { FilterListReducerFieldName } from '../../modules/filter/FilterListReducers';
import { Auth } from '../../modules/auth/Auth';
import PaperedTable from '../../components/Table/PaperedTable';
import { ListPropsInterface } from '../../modules/lib/ListPropsInterface';
import { PlusNotifyHelper } from '../../helpers/PlusNotifyHelper';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';
import {InvoiceToCsv} from "../../modules/document/InvoiceToCsv";
import {NotificationToCsv} from "../../modules/notifications/NotificationToCsv";
import {NotificationHelper} from "../../helpers/NotificationHelper";

interface NotificationListProps extends ListPropsInterface {
    simCard: SimCardInterface;
    showPartner?: boolean;
    plusNotify?: PlusNotifyInterface | null;
}

interface NotificationListState {
    filters: Array<Filter>;
    orders: Array<Order>;
    plusNotify?: PlusNotifyCollectionInterface | null;
    platformResellers: Array<HeaderCheckBoxSelectListElement> | null;
    open: boolean;
    details: React.ReactElement<any, string | React.JSXElementConstructor<any>> | null;
    showPartner?: boolean;
    showClearFilterButton: boolean;
    activeRow: number;
}

class NotificationList extends PureComponent<NotificationListProps, NotificationListState> {
    private itemLoader: ItemLoaders;
    private platformResellersLoader: PlatformResellerLoader;
    private filterManage: FilterManager;

    constructor(props: NotificationListProps, context: NotificationListState) {
        super(props, context);
        store.injectReducer('provisioningReducers', provisioningReducers);

        this.state = {
            filters: [],
            orders: [],
            plusNotify: null,
            platformResellers: null,
            open: false,
            details: null,
            showPartner: props.showPartner === undefined ? Auth.isAdminMode() : props.showPartner,
            showClearFilterButton: false,
            activeRow: 0,
        };

        this.itemLoader = new ItemLoaders(this.props.dispatch);
        this.platformResellersLoader = new PlatformResellerLoader(this.itemLoader);
        this.filterManage = new FilterManager();
    }

    componentDidMount(): void {
        // if (this.state.showPartner) {
        this.loadPlatformResellers();
        // } else {
        //     this.setDefaultFilter((): void => {});
        // }
    }

    componentDidUpdate(prevProps: Readonly<NotificationListProps>, prevState: Readonly<NotificationListState>, snapshot?: any): void {
        const { dispatch, headerFilterElementHasValue, headerFilterElementName } = this.props;
        if (headerFilterElementName) {
            if (headerFilterElementHasValue) {
                this.filterManage.manageElement(headerFilterElementName, headerFilterElementHasValue);
            } else {
                this.filterManage.manageElement(headerFilterElementName, false);
            }
            this.setState({ showClearFilterButton: this.filterManage.hasManageElement() });
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    setActiveRow = (id: number): void => {
        const { activeRow } = this.state;
        if (activeRow === id) {
            id = 0;
        }
        this.setState({ activeRow: id });
    };

    setDefaultFilter = (callback: () => void): void => {
        let filter: Array<Filter> = [];
        if (this.props.simCard) {
            filter = [{ name: 'msisdn', value: this.props.simCard.msisdn.substr(2) }];
        }

        this.setState(
            {
                showClearFilterButton: false,
                filters: filter,
                orders: [{ name: 'id', value: 'DESC' }],
            },
            (): void => {
                callback();
                this.firstLoad();
            }
        );
    };

    updateOrderList = (orders: Array<Order>): void => this.setState({ orders: orders }, this.firstLoad);
    updateFilterList = (filters: Array<Filter>): void => this.setState({ filters: filters });

    clearFilter = (): void => {
        this.setDefaultFilter((): void => {
            const { dispatch } = this.props;
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                clearAll: true,
            });
            dispatch({
                type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
            });
        });
    };

    paginationCallbackFunction = (uri: string): void => {
        if (this.props.showMainLoader) {
            this.props.showMainLoader(true);
        }
        this.itemLoader.paginationCallWithCallback(
            uri,
            provisionigConstants.NOTIFY_PLK_LIST,
            (data: PlusNotifyCollectionInterface): void => {
                this.setState({ plusNotify: data });
                if (this.props.showMainLoader) {
                    this.props.showMainLoader(false);
                }
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    firstLoad = (): void => {
        const { filters, orders } = this.state;
        const { dispatch } = this.props;
        if (this.props.showMainLoader) {
            this.props.showMainLoader(true);
        }
        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/notifies')),
            provisionigConstants.NOTIFY_PLK_LIST,
            filters,
            orders,
            (data: PlusNotifyCollectionInterface): void => {
                this.setState({ plusNotify: data });
                if (this.props.showMainLoader) {
                    this.props.showMainLoader(false);
                }
                dispatch({
                    type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
                    showRender: true,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    loadPlatformResellers = (): void => {
        this.platformResellersLoader.loadPlatformResellers({
            callback: () => {
                this.setState({ platformResellers: this.platformResellersLoader.getPlatformResellersHeaderList() }, (): void => {
                    this.setDefaultFilter((): void => {});
                });
            },
            filters: [{ name: 'deleted', value: 0 }],
        });
    };

    viewNotifyOn = (param: any): void =>
        this.setState({
            open: true,
            details: <NotifyView {...param} />,
        });

    viewNotifyOff = (): void => {
        this.setState({
            open: false,
            details: null,
        });
    };

    notificationType = (type: string): string => {
        return PlusNotifyHelper.notificationType(type);
    };

    notificationGroupType = (type: string | number): string => {
        return PlusNotifyHelper.notificationGroupType(type);
    };

    notificationGroupTypesList = (): Array<HeaderCheckBoxSelectListElement> => {
        return PlusNotifyHelper.notificationGroupTypesList();
    };

    notificationTypesList = (): Array<HeaderCheckBoxSelectListElement> => {
        return PlusNotifyHelper.notificationTypesList();
    };

    notificationDirectionList = (): Array<HeaderCheckBoxSelectListElement> => {
        return PlusNotifyHelper.notificationDirectionList();
    };

    threholdamount = (value: string, type: string): string => {
        return PlusNotifyHelper.threholdamount(value, type);
    };

    exportToCsv = (): void => {
        const {plusNotify} = this.state;
        const {dispatch,showMainLoader} = this.props;
        if(plusNotify && !plusNotify['hydra:totalItems']) {
            NotificationHelper.notifyError('general:common.no_data_to_export', dispatch);
            return;
        }
        const toCsv = new NotificationToCsv(new ItemLoaders(dispatch));
        toCsv.exportToCsv(this.state.orders, this.state.filters, showMainLoader);
    };

    render(): ReactNode {
        const { plusNotify, open, details, showPartner, platformResellers, filters, orders, showClearFilterButton, activeRow } = this.state;
        const { classes } = this.props;
        const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
        const tableStickyHeader = { root: classes.tableStickyHeader };
        const tableCellRoot = { root: classes.tableCellRootBordered };
        const tableRowRoot = { root: classes.tableRowRoot };
        const tableStickyCommand = { root: classes.tableStickyCommand };

        return (
            <GridContainer>
                <GridItem xs={12} md={12} lg={12}>
                    <PaperedTable
                        beforeTableContent={
                            <GridContainer>
                                <GridItem xs={12} className={classes.beforeTableContent}>
                                    <CustomTextButtom
                                        callback={this.firstLoad}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.search"
                                        size="lg"
                                    />
                                    {showClearFilterButton && (
                                        <CustomTextButtom
                                            callback={this.clearFilter}
                                            callbackParam={{}}
                                            color="primary"
                                            label="general:common.clear"
                                            size="lg"
                                        />
                                    )}
                                    <CustomTextButtom
                                        callback={this.exportToCsv}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.export_to_csv"
                                        size="lg"
                                    />
                                </GridItem>
                                <FilterList />
                            </GridContainer>
                        }
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell classes={tableStickyCommand} padding="none" align="left">
                                    <TableHeaderContentCell textAlign="left" title="general:common.commands" onlyFilter={true} />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.id"
                                        fieldName="id"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="number"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                {/*{showPartner && (*/}
                                <React.Fragment>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center">
                                        <TableHeaderContentCell
                                            title="prov:list.partner"
                                            textAlign="center"
                                            fieldName="platformResellerId"
                                            showSort={true}
                                            onlyFilter={false}
                                            defaultDirection="desc"
                                            searchFieldType="select"
                                            selectComponent="headerCheckBoxSimpleList"
                                            elementList={platformResellers}
                                            filters={filters}
                                            sort={orders}
                                            updateOrderList={this.updateOrderList}
                                            updateFilterList={this.updateFilterList}
                                            searchActionCallback={this.firstLoad}
                                        />
                                    </TableCell>
                                </React.Fragment>
                                {/*)}*/}
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.msisdn"
                                        fieldName="msisdnAll"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="string"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        textAlign="center"
                                        title="prov:list.notification_type"
                                        fieldName="typeGroupId"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        elementList={this.notificationGroupTypesList()}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        textAlign="center"
                                        title="prov:list.notification_direction"
                                        fieldName="notificationDirection"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        elementList={this.notificationDirectionList()}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="prov:list.notification_description"
                                        fieldName="description"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="string"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        textAlign="right"
                                        title="prov:list.event_date"
                                        fieldName="eventDate"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="date"
                                        dateFormat="RRRR-MM-DD"
                                        beforeSetToMax={true}
                                        afterSetToMin={true}
                                        dateFromTo={true}
                                        breakLine={true}
                                        timeFormat={false}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="center">
                                    <TableHeaderContentCell
                                        textAlign="right"
                                        title="prov:list.created_at"
                                        fieldName="createdAt"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="date"
                                        dateFormat="RRRR-MM-DD"
                                        beforeSetToMax={true}
                                        afterSetToMin={true}
                                        dateFromTo={true}
                                        breakLine={true}
                                        timeFormat={false}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {plusNotify &&
                                plusNotify['hydra:member'] &&
                                plusNotify['hydra:member'].map((row: PlusNotifyInterface) => {
                                    const desc = this.threholdamount(row.notify.threholddirection, row.notificationType.toString());
                                    let rowActiveColor = 'white';
                                    if (activeRow === row.id) {
                                        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
                                    }
                                    return (
                                        <TableRow
                                            key={'key' + row.id}
                                            onClick={(): void => {
                                                this.setActiveRow(row.id);
                                            }}
                                            classes={tableRowRoot}
                                            style={{ backgroundColor: rowActiveColor }}
                                            hover
                                        >
                                            <TableCell classes={tableControlStickyHeader} padding="none" align="left">
                                                <ViewButton callback={this.viewNotifyOn} callbackParam={row} />
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="center">
                                                {row.id}
                                            </TableCell>
                                            {/*{showPartner && (*/}
                                            <React.Fragment>
                                                <TableCell classes={tableCellRoot} padding="none" align="center">
                                                    {row.platformResellerName}
                                                </TableCell>
                                            </React.Fragment>
                                            {/*)}*/}
                                            <TableCell classes={tableCellRoot} padding="none" align="center">
                                                {row.msisdn.length === 9 && '48' + row.msisdn}
                                                {row.msisdn.length !== 9 && row.msisdn}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="center">
                                                {row.typeGroupId && <I18n trans={this.notificationGroupType(row.typeGroupId.toString())} />}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="center">
                                                {row.notificationType !== '1001' && row.notify.threholddirection && (
                                                    <I18n trans={'prov:list.' + row.notify.threholddirection} />
                                                )}
                                                {row.notificationType === '1001' && row.notificationDirection && (
                                                    <I18n trans={row.notificationDirection === 2 ? 'prov:list.DOWN' : 'prov:list.UP'} />
                                                )}
                                                {row.notificationType !== '1001' && !row.notify.threholddirection && (
                                                    <I18n trans={'prov:list.NONE'} />
                                                )}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="center">
                                                {row.description}
                                                {/*<I18n trans={desc} />*/}
                                                {/*{row.notificationType === '64' && row.notify.threholdamount}*/}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="center">
                                                {DateHelper.format(row.eventDate)}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="center">
                                                {DateHelper.format(row.createdAt)}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            {plusNotify && plusNotify['hydra:member'] && plusNotify['hydra:member'].length === 0 && (
                                <TableRow>
                                    <TableCell classes={tableCellRoot} colSpan={9} align="left">
                                        <I18n trans="general:common.empty_list" />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={10}>
                                    {plusNotify && plusNotify['hydra:view'] && (
                                        <Pager callback={this.paginationCallbackFunction} views={plusNotify} />
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                        <ViewDialog
                            maxWidth="lg"
                            title={'prov:list.view_notification'}
                            content={details}
                            agreeButtonName={'general:common.close'}
                            open={open}
                            callBackDisAgree={this.viewNotifyOff}
                        />
                    </PaperedTable>
                </GridItem>
            </GridContainer>
        );
    }
}

const stateToProps = (state: { filterReducer: FilterReducers }): object => {
    const { filterReducer } = state;
    if (filterReducer && filterReducer.headerFilterElementName) {
        return {
            headerFilterElementHasValue: filterReducer.headerFilterElementHasValue,
            headerFilterElementName: filterReducer.headerFilterElementName,
        };
    }
    return {};
};

export default compose<any, any>(connect(stateToProps), withStyles(oplAppStyle))(NotificationList);
